<section
  class="content-module"
  [ngClass]="isInteractive ? '' : borderPosition"
  [class.interactive]="isInteractive"
>
  <ng-container *ngIf="!isInteractive">
    <div class="border border--left" *ngIf="borderPosition === 'left'"></div>
    <div class="border border--top" *ngIf="borderPosition === 'top'"></div>
  </ng-container>

  <ng-content></ng-content>
</section>
